import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const snowflakePushDataProgressManager = {
  getSnowflakePushDataProgress(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default snowflakePushDataProgressManager;